import {ComponentProps, FC} from 'react';

export const IconShortsCourse: FC<ComponentProps<'svg'>> = ({...rest}) => {
    return (
        <svg
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...rest}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M10.8515 6.38323C10.8515 5.74981 10.338 5.23633 9.70459 5.23633H7.1005C6.46709 5.23633 5.9536 5.74981 5.9536 6.38323C5.9536 7.01664 6.46709 7.53013 7.1005 7.53013H9.70459C10.338 7.53013 10.8515 7.01664 10.8515 6.38323Z"
                fill="var(--color-icon-primary)"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M10.2533 11.6781C10.2533 11.0447 9.73982 10.5312 9.1064 10.5312H1.14644C0.513029 10.5312 -0.000455856 11.0447 -0.000455856 11.6781C-0.000455856 12.3116 0.513029 12.825 1.14644 12.825H9.1064C9.73982 12.825 10.2533 12.3116 10.2533 11.6781Z"
                fill="var(--color-icon-primary)"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M9.6687 17.018C9.6687 16.3846 9.15522 15.8711 8.5218 15.8711H4.33488C3.70146 15.8711 3.18797 16.3846 3.18797 17.018C3.18797 17.6514 3.70146 18.1649 4.33488 18.1649H8.5218C9.15522 18.1649 9.6687 17.6514 9.6687 17.018Z"
                fill="var(--color-icon-primary)"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M21.4305 4.22656C22.7963 4.22656 23.8595 5.4127 23.7107 6.77036L22.4137 18.5998C22.2861 19.7629 21.3036 20.6436 20.1335 20.6436H13.3961C12.0303 20.6436 10.9671 19.4575 11.116 18.0998L12.413 6.27036C12.5405 5.10726 13.523 4.22656 14.6931 4.22656H21.4305ZM20.5231 12.6983C20.4325 12.8821 20.17 13.0243 19.645 13.3088L16.8043 14.8481C16.2647 15.1405 15.9949 15.2867 15.7732 15.2688C15.5713 15.2524 15.3872 15.1558 15.2693 15.0042C15.1399 14.8378 15.1399 14.55 15.1399 13.9743V10.8956C15.1399 10.3199 15.1399 10.0321 15.2693 9.86564C15.3872 9.71406 15.5713 9.61742 15.7732 9.60108C15.9949 9.58315 16.2647 9.72934 16.8043 10.0217L19.645 11.5611C20.17 11.8456 20.4325 11.9878 20.5231 12.1715C20.6057 12.3389 20.6057 12.5309 20.5231 12.6983Z"
                fill="var(--color-icon-primary)"
            />
        </svg>
    );
};
